import QCContainer from './components/QCContainer'

// Sync route definition
export default {
  path       : '/qc/:device_string/:qcId',
  indexRoute : { component: QCContainer }
}



// WEBPACK FOOTER //
// ./src/routes/QC/index.js